import { render, staticRenderFns } from "./Sidebar-Technician.vue?vue&type=template&id=5dcd2464"
import script from "./Sidebar-Technician.vue?vue&type=script&lang=js"
export * from "./Sidebar-Technician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports